import { type AppInfo } from '../../../types';
import { useTranslation } from '../../../i18n/i18n';
import { useAnotherApp } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from './StatusScreen';

/**
 * "No install steps yet": the app has no store links we know of. It is
 * installed elsewhere (a government website), so "I have installed it"
 * continues to the QR code, as on the store install screen.
 */
export default function EmbeddedMissingInstallScreen({
  app,
  onInstalled,
  onBack,
}: {
  app?: AppInfo;
  onInstalled: () => void;
  onBack?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <EmbeddedStatusScreen
      visual="app"
      app={app}
      title={t('embedded.missing.title')}
      sub={t('embedded.missing.sub', { app: app?.name ?? '' })}
      primary={{ label: t('embedded.install.installed'), onClick: onInstalled }}
      secondary={useAnotherApp(onBack)}
    />
  );
}
